import { render } from "./DetailRegionalAndArea.vue?vue&type=template&id=2ed19674&scoped=true"
import script from "./DetailRegionalAndArea.vue?vue&type=script&lang=js"
export * from "./DetailRegionalAndArea.vue?vue&type=script&lang=js"

import "./DetailRegionalAndArea.vue?vue&type=style&index=0&id=2ed19674&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ed19674"

export default script